var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarMasha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "avatar-masha_svg__a",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "avatar-masha_svg__d",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.9%",
    y: "-4.4%",
    width: "117.8%",
    height: "108.9%",
    filterUnits: "objectBoundingBox",
    id: "avatar-masha_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.249480988 0",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "avatar-masha_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avatar-masha_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D0E3E4",
    xlinkHref: "#avatar-masha_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#avatar-masha_svg__b)",
    mask: "url(#avatar-masha_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.086 88.527h40.92L54.8 60.7a21.12 21.12 0 00-.045-3.49c-.906-8.953-12.091-12.871-17.641-12.871h-9.137c-5.55 0-16.735 3.918-17.64 12.872a21.143 21.143 0 00-.045 3.489l1.794 27.827z",
    fill: "#9F57C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.86 25.965a2.105 2.105 0 00-1.29-.278v-5.478c0-5.536-4.488-10.024-10.024-10.024-5.537 0-10.025 4.488-10.025 10.024v5.478a2.105 2.105 0 00-1.289.278c-.838.488-1.259 1.47-1.104 2.429l.399 2.477a2.232 2.232 0 002.017 1.868 9.974 9.974 0 002.442 5.912l.015.017a10.342 10.342 0 001.356 1.286l.064.05c.148.114.3.225.456.332l.066.045c.158.106.318.209.48.306l.062.035c.16.094.322.185.488.27l-.054 1.651c-.033 1.003-.478 1.97-1.28 2.573-.847.64-4.782 1.793-4.782 3.865 0 5.28 6.674 10.611 10.67 10.611h.037c3.996 0 10.67-5.33 10.67-10.61 0-2.073-3.934-3.227-4.782-3.866-.801-.603-1.247-1.57-1.28-2.573l-.053-1.651c.165-.085.327-.176.488-.27l.06-.035c.164-.097.324-.2.481-.306l.067-.045c.155-.107.307-.218.456-.333l.063-.049a10.305 10.305 0 00.91-.809l.038-.038c.14-.142.277-.288.409-.439l.015-.017a9.974 9.974 0 002.442-5.912 2.231 2.231 0 002.016-1.868l.4-2.477c.154-.958-.266-1.94-1.105-2.43",
    fill: "#FCDAC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.119 40.992c.165-.085.327-.176.488-.27l.06-.035c.164-.097.324-.2.481-.306l.067-.045c.155-.107.307-.218.456-.333l.063-.049a10 10 0 00.437-.363l.053-.048c.144-.129.284-.261.42-.398l.038-.038c.14-.142.277-.288.409-.439l.015-.017a9.973 9.973 0 002.442-5.912 2.231 2.231 0 002.016-1.868l.4-2.478a2.439 2.439 0 00-.351-1.705c-.798 2.182-1.735 3.68-2.213 3.786 1.97-9.072-11.042-6.892-14.84-13.152-5.777 5.047-5.245 11.199-4.995 12.772.067.136.116.227.253.508-.078-2.311.233-7.95 4.693-11.373 2.944 3.58 10.621 3.984 13.161 6.206 3.302 11.284-4.321 16.952-8.503 16.952-1.724 0-2.67-.567-4.196-1.395l-.054 1.651c-.01.331-.07.656-.17.968 2.093 1.285 5.856 2.913 9.17.729.213-.062.426-.13.64-.199a3.535 3.535 0 01-.386-1.498l-.054-1.651z",
    fill: "#F7ADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.434 8.82a6.037 6.037 0 00.985-3.285c0-3.76-3.556-6.808-7.942-6.808-4.387 0-7.943 3.048-7.943 6.808 0 1.112.313 2.16.864 3.086-12.152 4.048-5.63 19.534-2.761 21.853 0 0-1.758-7.314 4.923-13.152 3.798 6.26 16.81 4.08 14.84 13.152 1.637-.363 8.657-17.05-2.966-21.655",
    fill: "#FFD368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.064 13.265c3.138-2.567 12.266-.856 12.456-2.947.19-2.09-7.416-2.473-11.315-2.093-1.422-7.452 3.248-8.981 7.23-9.008a9.082 9.082 0 00-2.958-.49c-4.387 0-7.943 3.048-7.943 6.808 0 1.112.313 2.16.864 3.086-12.05 4.014-5.74 19.272-2.835 21.79-1.817-9.501 1.586-14.761 4.501-17.146",
    fill: "#FFF5C9"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  }))));
}
export default SvgAvatarMasha;